module.exports = __webpack_public_path__ + "img/2f8848702e5c86793c7303ce733e0e72.ce82a172.webp";